// src/routes/cases/CaseDetail.jsx
import React, { useEffect, useState, useContext } from "react";
import "react-toastify/dist/ReactToastify.css";
import "yet-another-react-lightbox/styles.css";

import { toast } from "react-toastify";

import moment from "moment-timezone";
import Dummy from "../../images/user.jpg";
import lowerStl from '../../images/lowerstl.png'
import upperStl from '../../images/upperstl.png'
import Lightbox from "yet-another-react-lightbox";
import Simulations from "./components/Simulations";
import bitescanStl from '../../images/bitescan.jpg'
import ChangeStatus from "./components/ChangeStatus";

import { BiMaleFemale } from "react-icons/bi";
import { FaUserShield } from "react-icons/fa";
import { CiMedicalCase } from "react-icons/ci";
import { MdLocationOn, MdOutlineAttachEmail, MdElderly } from "react-icons/md";
import { AiOutlineComment } from "react-icons/ai";
import { CaseService } from "../../api/CaseService";
import { TeamService } from "../../api/TeamsService";
import { useParams, useNavigate } from "react-router-dom";
import { NotificationService } from "../../api/NotificationService";
import { AuthContext } from "../../components/authcontext/AuthContext";

import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { BsTags } from "react-icons/bs";
import StlSourceRadio from "./components/StlSourceRadio";
import { CaseStatusLabel } from "./constants/CaseStatusLabel";
import { CapitalizeEachWord } from "../../helperFunctions/TextHelpers";

const CaseDetail = () => {
  const navigate = useNavigate();
  const [openImages, setOpenImages] = useState(false);
  const [imageSources, setImageSources] = useState([])
  const [openXrays, setOpenXrays] = useState(false);
  const [xraySources, setXraySources] = useState([])
  const { id } = useParams();
  const [plannerId, setPlannerId] = useState('')
  const [planners, setPlanners] = useState([])
  const [loading, setLoading] = useState(false);
  const [casee, setCasee] = useState({});
  const [lowerurl, setLowerUrl] = useState('')
  const [upperurl, setUpperUrl] = useState('')
  const [biteurl, setBiteUrl] = useState('')
  const [biteurl2, setBiteUrl2] = useState('')
  const [caseId, setCaseId] = useState('')
  const [caseIdn, setCaseIdn] = useState('')
  const [timezone] = useState("Asia/Karachi");
  const [chiefComplaintPdf, setChiefComplaintPdf] = useState(null);
  const [chiefComplaintZip, setChiefComplaintZip] = useState(null);
  const [chiefComplaintImage, setChiefComplaintImage] = useState(null);
  const [treatmentPlanPdf, setTreatmentPlanPdf] = useState(null);
  const [treatmentPlanZip, setTreatmentPlanZip] = useState(null);
  const [treatmentPlanImage, setTreatmentPlanImage] = useState(null);
  const { currentUser, isReadNot, updateIsReadNot } = useContext(AuthContext)

  const createdId = currentUser?.id
  const permissions = currentUser?.permissions

  const api_url = process.env.REACT_APP_API_URL

  const handleStlDownload = (url, name) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = `${name}.stl`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  const formatString = (input) => {
    // 1. Guard clause for null, undefined, or empty input
    if (!input) return "";

    return input
      .split(/[_-]/) // 2. Handles both underscores and hyphens
      .filter(Boolean) // 3. Removes empty strings (e.g., "slug__double")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // 4. Normalizes casing
      .join(' ');
  };
  
  // handle download all images
  const handleDownloadAllImages = async () => {
    const zip = new JSZip();

    // Add each image to the zip file
    await Promise.all(
      casee?.images?.map(async (img) => {
        const response = await fetch(`${api_url}/uploads/images/${img?.file_name}`);
        const blob = await response.blob();
        zip.file(img?.file_name, blob);
      })
    );

    // Generate the zip file and create a blob URL
    zip.generateAsync({ type: 'blob' })
      .then((zipBlob) => {
        saveAs(zipBlob, 'images.zip');
      })
      .catch((error) => {
        console.error('Error while generating zip file:', error);
      });

  };

  // handle download all images
  const handleDownloadAllXrays = async () => {
    const zip = new JSZip();

    // Add each image to the zip file
    await Promise.all(
      casee?.xrays?.map(async (img) => {
        const response = await fetch(`${api_url}/uploads/xrays/${img?.file_name}`);
        const blob = await response.blob();
        zip.file(img?.file_name, blob);
      })
    );

    // Generate the zip file and create a blob URL
    zip.generateAsync({ type: 'blob' })
      .then((zipBlob) => {
        saveAs(zipBlob, 'xrays.zip');
      })
      .catch((error) => {
        console.error('Error while generating zip file:', error);
      });
    
  };

  //get planners 
  const getPlannersApi = async (id) => {
    try {
      const result = await TeamService.getPlanners(id);

      if (result?.data?.status === 200) {
        setPlanners(result?.data?.data);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      toast.error(error?.result?.data?.errors[0], {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  //assign case to planner
  const assignCaseApi = async () => {
    setLoading(true);
    try {
      const formData = new FormData()

      if (caseIdn) {
        formData.append('p_case_id', caseIdn)
      }

      if (plannerId) {
        formData.append('user_id', plannerId)
      }
      
      if (casee?.status) {
        formData.append('p_case_status', casee?.status == '1' ? '2' : casee?.status)
      }

      const result = await CaseService.assignCase(formData);

      if (result?.data?.status === 200) {
        getCaseDetailFunction(id)
        createNotification("Case is Assigned", "Case is Assigned to Planner", plannerId)
        toast.success(result?.data?.message, {
          autoClose: 1500,
          pauseOnHover: true,
          draggable: true,
        });
      }
      else
      {
        toast.error(result?.data?.message, {
          autoClose: 1500,
          pauseOnHover: true,
          draggable: true,
        });
      }
      
    } catch (error) {
      toast.error(error?.result?.data?.errors[0], {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,

      });

    } finally {
      setLoading(false)
    }
  };

  //Create case notification
  const createNotification = async (title, body, userid) => {
    try {
      const formData = new FormData();

      formData.append('title', title);
      formData.append('body', body);
      formData.append('url_action', id);

      if (id) {
        formData.append('user_id', userid)
      }

      const result = await NotificationService.addNotification(formData);

      if (result?.data?.status === 200)
      {
        updateIsReadNot(!isReadNot)
        //  toast.success(result?.data?.message, {
        //   autoClose: 1000,
        //   pauseOnHover: true,
        //   draggable: true,
        // });
        setTimeout(() => {
          navigate('/cases')
        }, 1300)

      }
      else 
      {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,

        });
      }

    } catch (error) {
      toast.error(error?.result?.data?.errors[0], {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,

      });

    } finally {
      setLoading(false)
    }
  };

  //get case details
  const getCaseDetailFunction = async (id) => {
    try {
      const result = await CaseService.getCaseDetail(id);

      if (result?.data?.status === 200)
      {
        // console.log(result?.data?.data);
        setCasee(result?.data?.data);
        setCaseId(result?.data?.data?.guid)
        setCaseIdn(result?.data?.data?.id)

        setUpperUrl(`${api_url}/uploads/stl/${result?.data?.data?.stl_upper_file}`)
        setLowerUrl(`${api_url}/uploads/stl/${result?.data?.data?.stl_lower_file}`)


        setBiteUrl(`${api_url}/uploads/stl/${result?.data?.data?.stl_byte_scan_file}`)
        setBiteUrl2(`${api_url}/uploads/stl/${result?.data?.data?.stl_byte_scan_file2}`)

        if (result?.data?.data?.chief_complaint_zip) setChiefComplaintZip(`${api_url}/uploads/zip/${result?.data?.data?.chief_complaint_zip}`)
        if (result?.data?.data?.chief_complaint_pdf) setChiefComplaintPdf(`${api_url}/uploads/zip/${result?.data?.data?.chief_complaint_pdf}`)
        if (result?.data?.data?.treatment_plan_zip) setTreatmentPlanZip(`${api_url}/uploads/zip/${result?.data?.data?.treatment_plan_zip}`)
        if (result?.data?.data?.treatment_plan_pdf) setTreatmentPlanPdf(`${api_url}/uploads/zip/${result?.data?.data?.treatment_plan_pdf}`)
        if (result?.data?.data?.chief_complaint_image) setChiefComplaintImage(`${api_url}/uploads/images/${result?.data?.data?.chief_complaint_image}`)
        if (result?.data?.data?.treatment_plan_image) setTreatmentPlanImage(`${api_url}/uploads/images/${result?.data?.data?.treatment_plan_image}`)

        setImageSources(result?.data?.data?.images?.map((img) => ({
          src: `${api_url}/uploads/images/${img?.file_name}`
        })));

        setXraySources(result?.data?.data?.xrays?.map((xray) => ({
          src: `${api_url}/uploads/xrays/${xray?.file_name}`
        })))

      }
      else
      {
        if (result?.data?.message === "Unauthenticated.") {
          navigate('/login')
        }
        toast.error(result?.data?.message, {

          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,

        });
      }

    } catch (error) {
      toast.error(error?.result?.data?.errors[0], {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCaseDetailFunction(id);
    getPlannersApi(id);
  }, [id]);

  //change status to submission
  const updateStatusByClient = async (idd) => {
    if (!idd) {
      toast.error("Case not found", {
        autoClose: 1500,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      setLoading(true);
      try {
        const result = await CaseService.updateCaseToSubmission(
          idd,
          (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            // setProgress(percentCompleted);
          }
        );

        if (result?.data?.status === 200) {
          createNotification("Case is confirmed by Client", "Subclient Case is sent to case submission", createdId)

          toast.success(result?.data?.message, {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
          });

          setTimeout(() => {
            navigate("/cases");
          }, 1500);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } catch (error) {
        toast.error(error?.result?.data?.errors[0], {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      } finally {
        setLoading(false);
      }
    }
  };

  // Timer function
  const endTime = new Date(new Date(casee?.start_date_time).getTime() + parseInt(casee?.expected_time) * 3600 * 1000).getTime();

  // Calculate the initial remaining time in seconds
  const calculateRemainingTime = () => {
    const now = new Date().getTime();
    const remainingTime = Math.max((endTime - now) / 1000, 0);
    return remainingTime;
  };

  const [timeRemaining, setTimeRemaining] = useState(calculateRemainingTime());
  
  useEffect(() => {
    const updateTimer = () => {
      setTimeRemaining(calculateRemainingTime());
    };

    // Initial call to set the correct remaining time
    updateTimer();

    const intervalId = setInterval(updateTimer, 1000); // Update every second

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, [endTime]);

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    // return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    return { hrs: hrs.toString().padStart(2, '0'), mins: mins.toString().padStart(2, '0'), secs: secs.toString().padStart(2, '0') }
  };

  return (
    <div className="users-wrapper">
      {loading && (
        <div className="loader-parent">
          <div className="_loader"></div>
        </div>
      )}

      <div className="user-details">
        <div className="patinet-info">
          <div className="top-sticky-main">
            <div className="textt">
              <div className="info"> Time left  <span className="userr"></span>
                <div className="time-left">
                  <span>{formatTime(timeRemaining).hrs}</span> : <span>{formatTime(timeRemaining).mins}</span> : <span>{formatTime(timeRemaining).secs}</span>
                </div>
              </div>{
               casee?.status === 1 ? <div className="info">Case is created by <span className="userr">{casee?.created_user?.username}</span></div> :
               casee?.status === 2 ? <div className="info">Case is assigned to <span className="userr">{casee?.planner?.full_name}</span></div> :
               casee?.status === 3 ? <div className="info">Case is assigned to <span className="userr">{casee?.qa?.username}</span> for QC </div> :
               casee?.status === 4 ? <div className="info"><span className="userr">{casee?.planner?.full_name}</span> Holds case</div> :
               casee?.status === 5 ? <div className="info"><span className="userr">{casee?.created_user?.username}</span> Updated the case</div> :
               casee?.status === 6 ? <div className="info"><span className="userr">{casee?.qa?.username}</span> Rejected the case</div> :
               casee?.status === 7 ? <div className="info"><span className="userr">{casee?.qa?.username}</span> Submitted case for ortho check</div> :
               casee?.status === 8 ? <div className="info"><span className="userr">{casee?.created_user?.username}</span> Asked modifications</div> :
               casee?.status === 9 ? <div className="info"><span className="userr">{casee?.created_user?.username}</span> Required stl files</div> :
               casee?.status === 10 ? <div className="info"><span className="userr">{casee?.created_user?.username}</span> Required container files</div> :
               casee?.status === 11 ? <div className="info"><span className="userr">{casee?.post_processing?.username}</span> uploaded stl files</div> :
               casee?.status === 12 ? <div className="info"><span className="userr">{casee?.post_processing?.username}</span> uploaded container files</div> :
               casee?.status === 13 ? <div className="info"><span className="userr">{casee?.created_user?.username}</span> Need stl files modifications</div> :
               casee?.status === 14 ? <div className="info"><span className="userr">{casee?.created_user?.username}</span> Need container files modifications</div> :
               casee?.status === 15 ? <div className="info"><span className="userr">{casee?.created_user?.username}</span> Marked case as completed</div> : ""
              }
            </div>

          </div>
          <div className="top-sticky mb-3">
            
            {/* {(casee.verified_by_client == '0' && casee.sub_client_id && casee.status == '1') && <div className="update-by-client form-wrapper">
              <button className="button" onClick={()=>updateStatusByClient(id)}>Send case to case submission </button>
            </div>} */}

            {permissions?.includes("patient-cases-case-assign-to") &&
              <div>
                <div className="title">
                { casee?.planner?.full_name ? 
                  <>This case is assigned to <span>{casee?.planner?.full_name}</span></>
                  : 'Assign Case to Planner'
                }
                </div>
                <div className="row ">
                  <div className="col-12">
                    <div className="form-group form-wrapper">
                      <label htmlFor="">Select Planner</label>
                      <select className="input" value={plannerId} onChange={(e) => setPlannerId(e.target.value)}>
                        <option value="">Select planner</option>
                        {planners?.map((planer) => <option key={planer?.id} value={planer?.id}>{planer?.full_name}</option>)}
                      </select>
                      <div className="d-flex my-3">
                        {plannerId && <button className="button" onClick={() => assignCaseApi()}>Assign now</button>}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            }
            <ChangeStatus id={id} />
          </div>
          {
            ((casee?.status === 11 || casee?.status === 12 || casee?.status === 16) && <div className="check-stl-files">
              {casee?.stl_file_by_post_processing && <a className="button" href={`${api_url}/uploads/stl/${casee?.stl_file_by_post_processing}`} download={`${api_url}/uploads/stl/${casee?.stl_file_by_post_processing}`}>
                Download {casee?.status === 11 ? ' Stl Files' : casee?.status === 12 ? ' Container Files' : casee?.status === 16 ? 'direct printing files' : ''}
              </a>}
              {casee?.stl_file_by_post_processing_we_transfer_link &&
                <><p>If you are facing problem downloadin file click  below button to get download link </p>
                <p>
                  <a className="button" target="_link" href={casee?.stl_file_by_post_processing_we_transfer_link}>Download File by clicking this link</a>
                </p></>
              }
            </div>)
          }

          <div>
            <div className="title">Patient info</div>
            <div className="row mb-4">
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <div className="item_flex">
                  <CiMedicalCase /> <span>{casee?.case_id}</span>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <div className="item_flex">
                  <FaUserShield /> <span>{CapitalizeEachWord(casee?.name)}</span>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <div className="item_flex">
                  <MdOutlineAttachEmail /> <span>{casee?.email}</span>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <div className="item_flex">
                  <BiMaleFemale /> <span>{CapitalizeEachWord(casee?.gender)}</span>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <div className="item_flex">
                  <MdElderly /> <span>{casee?.age} Years</span>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <div className="item_flex">
                  <MdLocationOn /> <span>{CapitalizeEachWord(casee?.patient_location)}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="item_flex">
                <strong>Expected time: </strong> <span>{
                    casee?.expected_time === '8' ? "Express setup delivery: 8 hrs" :
                    casee?.expected_time === '24' ? 'Super Setup Delivery: 24 hrs' :
                    casee?.expected_time === '48' ? 'Normal Setup Delivery: 48 hrs' :
                    ''
                  }</span>
              </div>
            </div>
            {casee?.case_category && 
              <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="item_flex">
                <strong>Case Category: </strong><span>{casee?.case_category+' : '+ casee?.case_category_type}</span>
              </div>
            </div>
            }
            {casee?.case_doctor && 
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="item_flex">
                <strong>Case Doctor: </strong><span>{CapitalizeEachWord(casee?.case_doctor)}</span>
              </div>
            </div>
            }
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="item_flex">
                <strong>Tooth Label Format: </strong><span>{CapitalizeEachWord(casee?.tooth_label_format)}</span>
              </div>
            </div>
            {casee?.case_type && <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="item_flex">
                <strong>Case Type: </strong> <span>{CapitalizeEachWord(casee?.case_type)}</span>
              </div>
            </div>}
            {casee?.arch && <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="item_flex">
                <strong>Arch: </strong> <span>{casee?.arch}</span>
              </div>
            </div>}
            {casee?.ipr && <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="item_flex">
                <strong>IPR: </strong> <span>{casee?.ipr}</span>
              </div>
            </div>}
            {casee?.extraction && <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="item_flex">
                <strong>Extraction: </strong> <span>{casee?.extraction}</span>
              </div>
            </div>}
            {casee?.attachments && <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="item_flex">
                <strong>Attachments: </strong> <span>{casee?.attachments}</span>
              </div>
            </div>}
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="item_flex">
                <strong>Case Version: </strong> <span>{casee?.case_version}</span>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="item_flex">
                <strong>Scan Version: </strong> <span>{casee?.scan_version}</span>
              </div>
            </div>
          </div>

          <div>
            <div className="title">Chief complaint</div>
            <div
              className="custom-text"
              dangerouslySetInnerHTML={{
                __html: casee?.chief_complaint,
              }}
            ></div>
            <div className="buttons left mb-3">
              {chiefComplaintPdf && <a className="button" href={chiefComplaintPdf} target="blank">View PDF</a>}
              {chiefComplaintZip && <a className="button" href={chiefComplaintZip} target="blank">View Zip</a>}
              {chiefComplaintImage && <a className="button" href={chiefComplaintZip} target="blank">View Image</a>}

              {/* displa the list of case PDFs */}
              {casee?.pdfs?.map((pdf) => (
                <a className="button" key={pdf.id} href={`${api_url}/uploads/pdf/${pdf.file_name}`} target="blank"> 
                View PDF ({moment(pdf.created_at).tz(timezone).fromNow()})
                </a>
              ))}
            </div>
            <div className="title">Treatment Plan</div>
            <div
              className="custom-text"
              dangerouslySetInnerHTML={{
                __html: casee?.treatment_plan,
              }}
            ></div>
            <div className="buttons left mb-3">
              {treatmentPlanPdf && <a className="button" href={treatmentPlanPdf} target="blank">View PDF</a>}
              {treatmentPlanZip && <a className="button" href={treatmentPlanZip} target="blank">View Zip</a>}
              {treatmentPlanImage && <a className="button" href={treatmentPlanImage} target="blank">View Image</a>}
            </div>
          </div>

          <div>
            <Lightbox open={openImages} close={() => setOpenImages(false)} slides={imageSources} />
            <div className="title">Patient Images</div>
            {casee?.images?.length > 0 && <div className="buttons">
              <button className="button" onClick={() => setOpenImages(true)}>View  images</button>
              {/* <button className="button" onClick={handleDownloadAllImages}>Download zip for case {casee?.name}</button> */}
            </div>}
            <div className="files-wrapper mb-4">
              {casee?.images?.map((img) => (
                <div className="image" key={img?.id} >
                  <img alt="" src={`${api_url}/uploads/images/${img?.file_name}`} />
                </div>
              ))}
            </div>
          </div>

          <div>
            <Lightbox open={openXrays} close={() => setOpenXrays(false)} slides={xraySources} />
            <div className="title">X-Ray Files</div>
            {casee?.xrays?.length > 0 && <div className="buttons">
              <button className="button" onClick={() => setOpenXrays(true)}>View  images</button>
              {/* <button className="button" onClick={handleDownloadAllXrays}>Download zip for case {casee?.name}</button> */}
            </div>}
            <div className="files-wrapper mb-4">
              {casee?.xrays?.map((img) => (
                <div className="image" key={img?.id}>
                  <img alt="" src={`${api_url}/uploads/xrays/${img?.file_name}`}/>
                </div>
              ))}
            </div>
          </div>

          <div className="mb-4">
            <div className="row">

              {/* Only AF Cases eligible to display this section */}
              { (casee?.created_user?.id === 208 && casee?.stl_files_storage_location) && <div>
                  <StlSourceRadio currentSource={casee.stl_files_storage_location} />
                </div>
              }
              
              <div className="col-12 col-md-3 col-lg-3">
                <div className="title mb-3">Stl Upper File</div>
                {upperurl && (
                  <div className="stl-main-viewr mb-5">
                    <img src={upperStl} alt="" />
                    {casee?.stl_upper_file && <button className="button" onClick={() => handleStlDownload(upperurl, 'upperstl')}>Download upper stl for case {casee?.name}</button>
                    }
                  </div>
                )}
              </div>

              <div className="col-12 col-md-3 col-lg-3">
                <div className="title mb-3">Stl Lower File</div>
                {lowerurl && (
                  <div className="stl-main-viewr mb-5">
                    <img src={lowerStl} alt="" />
                    {casee?.stl_lower_file &&
                      <button className="button" onClick={() => handleStlDownload(lowerurl, 'lowerstl')}>Download lower stl for case {casee?.name}</button>
                    }
                  </div>
                )}
              </div>

              <div className="col-12 col-md-3 col-lg-3">
                <div className="title mb-3">Stl BIte Scan File</div>
                {biteurl && (
                  <div className="stl-main-viewr mb-5">
                    <img src={bitescanStl} alt="" />
                    {casee?.stl_byte_scan_file &&
                      <button className="button" onClick={() => handleStlDownload(biteurl, 'bitescanstl')}>Download bite scan stl for case {casee?.name}</button>
                    }
                  </div>
                )}
              </div>

              <div className="col-12 col-md-3 col-lg-3">
                <div className="title mb-3">Stl BIte Scan File 2</div>
                {biteurl2 && (
                  <div className="stl-main-viewr mb-5">
                    <img src={bitescanStl} alt="" />
                    {casee?.stl_byte_scan_file &&
                      <button className="button" onClick={() => handleStlDownload(biteurl2, 'bitescanstl')}>Download bite scan stl for case {casee?.name}</button>
                    }
                  </div>
                )}
              </div>

            </div>
          </div>

          <Simulations caseId={caseId} />

          <div className="title">Case history {currentUser?.role_name} </div>

          <div className="history-wrapper">
            {casee?.case_status_users?.map((cas) => (currentUser?.role_name === 'client' || currentUser?.role_name === 'sub_client') ? 
            <div className="single-case">
              
              {(cas?.case_status !== 2 && cas?.case_status !== 6 && cas?.case_status !== 3) && <div className="image"><BsTags /></div>}
              
              {(cas?.case_status !== 2 && cas?.case_status !== 6 && cas?.case_status !== 3) && <div>
                <div className="header">
                  <div className="tit">{ CaseStatusLabel[cas.case_status] }</div>

                  <div className="sub_header">
                    <div className="inner">
                      <span className="label">Name:</span>
                      <span className="value">({cas.user_detail?.first_name} {cas.user_detail?.last_name})</span>
                    </div>
                    <div className="inner">
                      <span className="label">Role:</span>
                      <span className="value">({formatString(cas.user_detail?.role_name)})</span>
                    </div>
                  </div>

                  <div className="date">
                    {moment(cas.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(cas.created_at).tz(timezone).format('HH:mm:ss')}
                  </div>
                </div>
              </div>}

              <div className="bodyy">
                <div className="profile mb-3">
                  {(cas?.case_status !== 2 && cas?.case_status !== 6 && cas?.case_status !== 3) && <img alt="" src={`${api_url}/uploads/${cas?.user_detail?.profile_pic}`} />}

                  <div className="textt">
                    {cas?.case_status === 1 ? <div className="info"> Case is created by <span className="userr">{cas?.user_detail?.first_name} {cas?.user_detail?.last_name} </span></div> :
                     
                      cas?.case_status === 4 ? <div className="info">
                        <span className="userr"> {casee?.planner?.full_name} </span> Holds case
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                      
                      cas?.case_status === 5 ? <div className="info">
                        <span className="userr">{casee?.created_user?.first_name} {casee?.created_user?.last_name}</span> Updated the case
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} : {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                    
                      cas?.case_status === 7 ? <div className="info">
                        <span className="userr">{casee?.qa?.first_name} {casee?.qa?.last_name}</span> Submitted case for ortho check
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} : {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>
                          
                          {comnt?.instructions && (
                            <div>
                              <h6>Instructions (Setup ID: {comnt?.setup_id})</h6>
                              <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.instructions }}></div>
                            </div>
                          )}
                          
                          {comnt?.checklist_actions && (
                            <div>
                              <h6>Check List Actions</h6>
                              <ul className="custom-text comment-body" style={{ paddingLeft: '1.5rem', listStyleType: 'disc', marginTop: '0.5rem' }}>
                                {comnt.checklist_actions.split(' | ').map((action, index) => (
                                  <li key={index}>{action}</li>
                                ))}
                              </ul>
                            </div>
                          )}

                          </div>)}
                      </div> :
                    
                      cas?.case_status === 8 ? <div className="info">
                        <span className="userr">{casee?.created_user?.first_name} {casee?.created_user?.last_name}</span> Asked modifications
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} : {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>

                          {comnt?.instructions && (
                            <div>
                              <h6>Instructions (Setup ID: {comnt?.setup_id})</h6>
                              <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.instructions }}></div>
                            </div>
                          )}
                          
                          {comnt?.checklist_actions && (
                            <div>
                              <h6>Check List Actions</h6>
                              <ul className="custom-text comment-body" style={{ paddingLeft: '1.5rem', listStyleType: 'disc', marginTop: '0.5rem' }}>
                                {comnt.checklist_actions.split(' | ').map((action, index) => (
                                  <li key={index}>{action}</li>
                                ))}
                              </ul>
                            </div>
                          )}

                        </div>)}
                      </div> :
                      
                      cas?.case_status === 9 ? <div className="info">
                        <span className="userr">{casee?.created_user?.first_name} {casee?.created_user?.last_name}</span> Required stl files
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} : {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                    
                      cas?.case_status === 10 ? <div className="info">
                        <span className="userr">{casee?.created_user?.first_name} {casee?.created_user?.last_name}</span> Required container files
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                      
                      cas?.case_status === 11 ? <div className="info">
                        <span className="userr">{casee?.post_processing?.first_name} {casee?.post_processing?.last_name}</span> uploaded stl files
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon">
                              <AiOutlineComment />  </div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                    
                      cas?.case_status === 12 ? <div className="info">
                        <span className="userr">{casee?.post_processing?.first_name} {casee?.post_processing?.last}</span> uploaded container files
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                    
                      cas?.case_status === 13 ? <div className="info">
                        <span className="userr">{casee?.created_user?.first_name} {casee?.created_user?.lastt_name}</span> Need stl files modifications
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>
                        </div>)}
                      </div> :

                      cas?.case_status === 14 ? <div className="info">
                        <span className="userr">{casee?.created_user?.first_name} {casee?.created_user?.lastt_name}</span> Need container files modifications
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                    
                      cas?.case_status === 15 && cas?.created_by === 288 ? <div className="info">
                        <span className="userr">{casee?.created_user?.first_name} {casee?.created_user?.lastt_name}</span> Plan Approved
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                    
                      // cas?.case_status === 16 ? <div className="info">
                      //   <span className="userr">{casee?.post_processing?.first_name} {casee?.post_processing?.last}</span> Uploaded Direct Printing files
                      //   {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                      //     <div className="top">
                      //       <div className="icon"><AiOutlineComment /></div>
                      //       <div className="date">
                      //         {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                      //       </div>
                      //     </div>
                      //     <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>
                      //   </div>)}
                      // </div> :
                    
                      // cas?.case_status === 17 ? <div className="info">
                      //   <span className="userr">{casee?.created_user?.first_name} {casee?.created_user?.lastt_name}</span> Required Direct Printing files
                      //   {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                      //     <div className="top">
                      //       <div className="icon"><AiOutlineComment /></div>
                      //       <div className="date">
                      //         {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                      //       </div>
                      //     </div>
                      //     <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>

                      //   </div>)}
                      // </div> :
                    
                      cas?.case_status === 18 ? <div className="info">
                        <span className="userr">{casee?.created_user?.username}</span> Marked case as completed
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>
                        </div>)}
                      </div> : ""
                    }
                  </div>

                </div>
              </div>

            </div> :
            
            <div className="single-case">
              <div className="image"><BsTags /></div>
              
              <div className="header">
                <div className="tit">{ CaseStatusLabel[cas.case_status] }</div>
                <div className="sub_header">
                  <div className="inner">
                    <span className="label">Name:</span>
                    <span className="value">({cas.user_detail?.first_name} {cas.user_detail?.last_name})</span>
                  </div>
                  <div className="inner">
                    <span className="label">Role:</span>
                    <span className="value">({formatString(cas.user_detail?.role_name)})</span>
                  </div>
                </div>
                <div className="date">
                  {moment(cas.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(cas.created_at).tz(timezone).format('HH:mm:ss')}
                </div>
              </div>

              <div className="bodyy">
                <div className="profile mb-3">
                  {cas?.user_detail ? <img alt="" src={`${api_url}/uploads/${cas?.user_detail?.profile_pic}`} /> : <img src={Dummy} alt="default-image" />}

                  <div className="textt">
                    {cas?.case_status === 1 ? <div className="info"> Case is created by <span className="userr">{cas?.user_detail?.first_name} {cas?.user_detail?.last_name} </span></div> :
                     
                      cas?.case_status === 2 ? <div className="info">Case is assigned to <span className="userr">{casee?.planner?.full_name}</span>
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>
                        </div>)}
                      </div> :

                      cas?.case_status === 3 ? <div className="info">
                        Case is assigned to <span className="userr">{casee?.qa?.first_name} {casee?.qa?.last_name}</span> for QC
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                    
                      cas?.case_status === 4 ? <div className="info">
                        <span className="userr"> {casee?.planner?.full_name} </span> Holds case
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon">
                              <AiOutlineComment />  </div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                      
                      cas?.case_status === 5 ? <div className="info">
                        <span className="userr">{casee?.created_user?.first_name} {casee?.created_user?.last_name}</span> Updated the case
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{__html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                    
                      cas?.case_status === 6 ? <div className="info">
                        <span className="userr">{casee?.qa?.first_name} {casee?.qa?.last_name}</span> Rejected the case
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{__html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                    
                      cas?.case_status === 7 ? <div className="info">
                        <span className="userr">{casee?.qa?.first_name} {casee?.qa?.last_name}</span> Submitted case for ortho check
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{__html: comnt?.comments }}></div>
                                                    
                          {comnt?.instructions && (
                            <div>
                              <h6>Instructions (Setup ID: {comnt?.setup_id})</h6>
                              <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.instructions }}></div>
                            </div>
                          )}
                          
                          {comnt?.checklist_actions && (
                            <div>
                              <h6>Check List Actions</h6>
                              <ul className="custom-text comment-body" style={{ paddingLeft: '1.5rem', listStyleType: 'disc', marginTop: '0.5rem' }}>
                                {comnt.checklist_actions.split(' | ').map((action, index) => (
                                  <li key={index}>{action}</li>
                                ))}
                              </ul>
                            </div>
                          )}

                        </div>)}
                      </div> :
                    
                      cas?.case_status === 8 ? <div className="info">
                        <span className="userr">{casee?.created_user?.first_name} {casee?.created_user?.last_name}</span> Asked modifications
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{__html: comnt?.comments }}></div>
                          
                          {comnt?.instructions && (
                            <div>
                              <h6>Instructions (Setup ID: {comnt?.setup_id})</h6>
                              <div className="custom-text comment-body" dangerouslySetInnerHTML={{ __html: comnt?.instructions }}></div>
                            </div>
                          )}
                          
                          {comnt?.checklist_actions && (
                            <div>
                              <h6>Check List Actions</h6>
                              <ul className="custom-text comment-body" style={{ paddingLeft: '1.5rem', listStyleType: 'disc', marginTop: '0.5rem' }}>
                                {comnt.checklist_actions.split(' | ').map((action, index) => (
                                  <li key={index}>{action}</li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>)}
                      </div> :
                    
                      cas?.case_status === 9 ? <div className="info">
                        <span className="userr">{casee?.created_user?.first_name} {casee?.created_user?.last_name}</span> Required stl files
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{__html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                    
                      cas?.case_status === 10 ? <div className="info">
                        <span className="userr">{casee?.created_user?.first_name} {casee?.created_user?.last_name}</span> Required container files
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{__html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                    
                      cas?.case_status === 11 ? <div className="info">
                        <span className="userr">{casee?.post_processing?.first_name} {casee?.post_processing?.last_name}</span> uploaded stl files
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{__html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                    
                      cas?.case_status === 12 ? <div className="info">
                        <span className="userr">{casee?.post_processing?.first_name} {casee?.post_processing?.last_name}</span> uploaded container files
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{__html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                    
                      cas?.case_status === 13 ? <div className="info">
                        <span className="userr">{casee?.created_user?.first_name} {casee?.created_user?.last_name}</span> Need stl files modifications
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{__html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                    
                      cas?.case_status === 14 ? <div className="info">
                        <span className="userr">{casee?.created_user?.first_name} {casee?.created_user?.last_name}</span> Need container files modifications
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{__html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                    
                      cas?.case_status === 15 ? <div className="info">
                        <span className="userr">{casee?.created_user?.first_name} {casee?.created_user?.lastt_name}</span> Plan Approved
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{__html: comnt?.comments }}></div>
                        </div>)}
                      </div> :
                    
                      // cas?.case_status === 16 ? <div className="info">
                      //   <span className="userr">{casee?.post_processing?.first_name} {casee?.post_processing?.last}</span> Uploaded Direct Printing files
                      //   {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                      //     <div className="top">
                      //       <div className="icon"><AiOutlineComment /></div>
                      //       <div className="date">
                      //         {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                      //       </div>
                      //     </div>
                      //     <div className="custom-text comment-body" dangerouslySetInnerHTML={{__html: comnt?.comments }}></div>
                      //   </div>)}
                      // </div> :
                    
                      // cas?.case_status === 17 ? <div className="info">
                      //   <span className="userr">{casee?.created_user?.first_name} {casee?.created_user?.lastt_name}</span> Required Direct Printing files
                      //   {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                      //     <div className="top">
                      //       <div className="icon"><AiOutlineComment /></div>
                      //       <div className="date">
                      //         {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                      //       </div>
                      //     </div>
                      //     <div className="custom-text comment-body" dangerouslySetInnerHTML={{__html: comnt?.comments }}></div>
                      //   </div>)}
                      // </div> :
                    
                      cas?.case_status === 18 ? <div className="info">
                        <span className="userr">{casee?.created_user?.username}</span> Marked case as completed
                        {cas?.cases_status_users_comments?.map((comnt) => <div className="comment" key={comnt?.id}>
                          <div className="top">
                            <div className="icon"><AiOutlineComment /></div>
                            <div className="date">
                              {moment(comnt.created_at).tz(timezone).format('ddd, MMM DD YYYY')} :  {moment(comnt.created_at).tz(timezone).format('HH:mm:ss')}
                            </div>
                          </div>
                          <div className="custom-text comment-body" dangerouslySetInnerHTML={{__html: comnt?.comments }}></div>
                        </div>)}
                      </div> : ""  
                    }
                  </div>
                </div>

              </div>
            </div>)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseDetail;
